import { AppFetcher, AppInfoList, AppPage, AppWidget } from '@launchpad';
import { AppPadding } from '@launchpad/components/widgets/AppPadding';
import moment from 'moment';
import React from 'react';
import { AppBadge } from '@launchpad/components/typography';
import AuthorisationImportFileModel from '../../models/AuthorisationImportFileModel';
import AuthorisationImportFileRows from '../../components/files/AuthorisationImportFileRows';

const AuthorisationFileDetails = (props) => {
  return (
    <AppFetcher
      model={AuthorisationImportFileModel}
      id={props.match.params.id}
      isIdInUrl
      renderContent={(record) => {
        const details = [
          {
            label: 'Name',
            value: record.name,
          },
          {
            label: 'Status',
            value: <AppBadge text={record.status} />,
          },
          {
            label: 'Created',
            value: moment(record.created).format('DD/MM/YYYY HH:mm:ss'),
          },
        ];

        const stats = [
          {
            label: 'Row count',
            value: record?.stats?.totalRowCount ?? '-',
          },
        ];
        return (
          <AppPage title="Details of the import file" icon="list">
            <div className="row">
              <div className="col-sm-6">
                <AppWidget title="Basic info">
                  <AppPadding>
                    <AppInfoList items={details} />
                  </AppPadding>
                </AppWidget>
              </div>
              <div className="col-sm-6" style={{ display: 'none' }}>
                <AppWidget title="Stats">
                  <AppPadding>
                    <AppInfoList items={stats} />
                  </AppPadding>
                </AppWidget>
              </div>
            </div>
            <div style={{ marginTop: 15 }} />
            <div className="row">
              <div className="col-sm-12">
                <AuthorisationImportFileRows file={record} />
              </div>
            </div>
          </AppPage>
        );
      }}
    />
  );
};

export default AuthorisationFileDetails;
